var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOnlyEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "44.047px",
    height: "35.406px",
    viewBox: "0 0 44.047 35.406",
    enableBackground: "new 0 0 44.047 35.406",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "outer",
    fill: "#F15A24",
    d: "M30.666-0.001l-8.643,8.529l-8.641-8.529L0,13.382l22.023,22.024l22.024-22.024L30.666-0.001z  M22.023,28.344L7.071,13.393l6.339-6.346l8.612,8.5l8.619-8.5l6.338,6.347L22.02,28.354L22.023,28.344z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOnlyEmpty);
export default __webpack_public_path__ + "static/media/heart-only-empty.86f355370819a6b64b4edb3156a3dd29.svg";
export { ForwardRef as ReactComponent };